import { render, staticRenderFns } from "./TopCourse.vue?vue&type=template&id=5e8bc994&scoped=true&"
import script from "./TopCourse.vue?vue&type=script&lang=js&"
export * from "./TopCourse.vue?vue&type=script&lang=js&"
import style0 from "./TopCourse.vue?vue&type=style&index=0&id=5e8bc994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8bc994",
  null
  
)

export default component.exports